module.exports = {
          srcSet: __webpack_public_path__ + "c97ad124a70ce9493a6b5c0d29077b08-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "c97ad124a70ce9493a6b5c0d29077b08-120.png",width: 120,height: 4}],
          src: __webpack_public_path__ + "c97ad124a70ce9493a6b5c0d29077b08-120.png",
          toString:function(){return __webpack_public_path__ + "c97ad124a70ce9493a6b5c0d29077b08-120.png"},
          
          width: 120,
          height: 4
        }